export default {
  login: {
    title: "Login to Excoino",
    description:
      "Access your Excoino wallet & crypto trading panel by logging in to your account"
  },
  register: {
    title: "Register on online cryptocurrency exchange | Excoino",
    description:
      "Register easily with your national ID to start secure crypto trading on Excoino"
  },
  virtualTrading: {
    title: "Demo Trading | Excoino",
    description:
      "Practice crypto trading with Excoino’s risk-free demo environment — perfect for beginners"
  }
};
